import { render, staticRenderFns } from "./ChatRoomAutoRegister.vue?vue&type=template&id=45d2f206&scoped=true"
import script from "./ChatRoomAutoRegister.vue?vue&type=script&lang=js"
export * from "./ChatRoomAutoRegister.vue?vue&type=script&lang=js"
import style0 from "./ChatRoomAutoRegister.vue?vue&type=style&index=0&id=45d2f206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2f206",
  null
  
)

export default component.exports